<template>
    <q-table
        ref="table"
        :data="data"
        :columns="columns"
        row-key="id"
        :pagination.sync="server_pagination"
        @request="request"
        :loading="loading"
        :no-data-label="$t('no_data_avaliable')"
        :no-results-label="$t('no_results_found')"
        :loading-label="$t('loading_data')"
        :rows-per-page-label="$t('items_per_page')"
        :rows-per-page-options="[5,10,50,100]"
        binary-state-sort
        class="q-mt-lg"
        >

        <q-tr slot="header" slot-scope="props" :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
            {{ $t(col.label) }}
            </q-th>
        </q-tr>

        <template slot="body" slot-scope="props">
            <q-tr :props="props">
                <q-td key="title" :props="props">
                    {{ props.row.title }}
                </q-td>

                <q-td key="qty_group_training_modules" :props="props">
                    {{ props.row.qty_group_training_modules }}
                </q-td>

                <q-td key="qty_group_training_modules_user_watch" :props="props">
                    {{ $t(props.row.qty_group_training_modules_user_watch) }}
                </q-td>

                <q-td key="qty_group_training_tests" :props="props">
                    {{ props.row.qty_group_training_tests }}
                </q-td>

                <q-td key="qty_group_training_tests_user_approved" :props="props">
                    {{ props.row.qty_group_training_tests_user_approved }}
                </q-td>

                <q-td key="group_training_user_progress" :props="props">
                    {{ props.row.group_training_user_progress }}%
                </q-td>
            </q-tr>
        </template>
    </q-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    name: 'UserReportCoursePendingTab',

    data() {
        return {
            loading: false,
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            columns: [
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    sortable: false,
                },
                {
                    name: 'qty_group_training_modules',
                    required: true,
                    label: 'classes',
                    align: 'left',
                    field: 'qty_group_training_modules',
                    sortable: false,
                },
                {
                    name: 'qty_group_training_modules_user_watch',
                    required: true,
                    label: 'watched_classes',
                    align: 'left',
                    field: 'qty_group_training_modules_user_watch',
                    sortable: false,
                },
                {
                    name: 'qty_group_training_tests',
                    required: true,
                    label: 'tests',
                    align: 'left',
                    field: 'qty_group_training_tests',
                    sortable: false,
                },
                {
                    name: 'qty_group_training_tests_user_approved',
                    required: true,
                    label: 'approvals',
                    align: 'left',
                    field: 'qty_group_training_tests_user_approved',
                    sortable: false,
                },
                {
                    name: 'group_training_user_progress',
                    required: true,
                    label: 'progress',
                    align: 'left',
                    field: 'group_training_user_progress',
                    sortable: false,
                }
            ],
            data: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            selected_user: 'users/selected_user',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
    },

    methods: {
        request({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`/admin_users/users/${this.selected_user}/get_user_group_training_progress/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.data = []

                response.data.results.forEach(result => {
                    this.data.push(result)
                })

                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        getDateFormated(d) {
            return date.formatDate(d, 'DD/MM/YYYY HH:mm:ss')
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        }
    },

    watch: {
        num_rows: {
            handler (newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()

        this.request({ pagination: this.server_pagination })
    }
}
</script>

<style>

</style>
